/*
 * @Author: caiqin.xie
 * @since: 2023-08-15 15:55:34
 * @lastTime: 2023-11-27 11:06:02
 * @LastEditors: caiqin.xie
 * @message: 服务支持-产品支持
 * @url: www.picoxr.com/cn/support/product-support
 */
import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";
import Header from "@/components/Header/index";
import Footer from "@/components/Footer/index";
import { BackTop } from "@arco-design/web-react";
import { IconCaretUp } from "@arco-design/web-react/icon";
import ProductBanner from "./components/ProductBanner";
import QuickStart from "./components/QuickStart";
import PopularForums from "./components/PopularForums";
import request from '@/common/request'
import { DOMAIN_API, POPULARFORUMSTYPE, COUNTRY_HREFLANG, COUNTRY_LIST } from '@/common/const'
import { IProduct } from "@/common/types";
import styles from "./index.module.scss";

const ProductSupport = (props: any) => {
  const {ctry, words, data} = props.data
  const location = useLocation()
  const [product, setProduct] = useState<IProduct>(data?.product || null) // 产品信息
  const [blogList, setBlogList] = useState(data?.contents?.records || []) // 热门论坛
  const [pages, setPages] = useState<number>(data?.contents?.pages * 1 || 1) // 热门论坛总页数

  // 获取PopularForums列表
  const getBlogList = (pageNum: number) => {
    const labelName = location.pathname.split('/').pop()
    request.post(`${DOMAIN_API}/o/official/content/getContentPage`, {
      contentTypeId: POPULARFORUMSTYPE,
      stationCode: ctry,
      labelName,
      page: pageNum,
      rows: 8
    })
    .then(res => {
      console.log(res)
      const list = [...blogList, ...res.data.records]
      setBlogList(list)
    })
    .catch(err => {
      console.log(err)
    })
  }

  // 生成hreflang
  const renderHrefLang = () => {
    return (
      COUNTRY_LIST.map(item => (
        <link key={item} rel="alternate" hrefLang={COUNTRY_HREFLANG[item]} href={`${DOMAIN_API}/${item}/support/product-support`} />
      ))
    )
  }


  return (
    <div>
      <Helmet>
        <title>{words.support_product_seo_title}</title>
        <meta name="description" content={words.support_product_seo_description} />
        <meta name="keywords" content={words.support_product_seo_keywords} />
        <link rel="canonical" href={`${DOMAIN_API}/${ctry}/support/product-support`} />
        {renderHrefLang()}
      </Helmet>
      <Header ctry={ctry} words={words}/>
      <main className={styles['product-wrap']}  id='product'>
        <div className={styles['product-content-wrap']}>
          {/* 产品图 */}
          <ProductBanner ctry={ctry} words={words} product={product} />
          {/* 快速开始 */}
          <QuickStart ctry={ctry} words={words} productId={product?.id} />
          {/* 热门论坛 */}
          <PopularForums
            ctry={ctry}
            words={words}
            blogList={blogList}
            pages={pages}
            getBlogList={getBlogList} />
          {/* 返回顶部 */}
          <BackTop
            visibleHeight={ 200 }
            target={() => document.documentElement}
          >
            <div className={styles['custom-backtop']} tabIndex={0} role='button'>
              <IconCaretUp />
              <br />
              TOP
            </div>
          </BackTop>
        </div>
      </main>
      <Footer />
    </div>
  );
};

function getInit(ctry: string, pathName: string) {
  return new Promise((resolve, reject) => {
    const decodedUrl = decodeURIComponent(pathName);
    const labelName = decodedUrl.split('?')[0].split('/').pop();
    request.post(`${DOMAIN_API}/o/official/product/getSupportSearchPage`, {
      contentTypeId: POPULARFORUMSTYPE,
      stationCode: ctry,
      labelName,
      page: 1,
      rows: 8
    })
    .then(res => {
      resolve(res.data)
    })
    .catch(err => {
      reject(err)
    })
  })
}

ProductSupport.getInitialProps = (ctry: string, pathName: string) => {
  return getInit(ctry, pathName)
};
export default ProductSupport;
